import { message } from 'antd';

const timeFlag = {};

const keyRender = (text) => {
  let key = `${text}-${Date.now()}`;

  if (text === 'Please login again') {
    key = text;
    
    timeFlag[text] = timeFlag[text] ? timeFlag[text] + 1 : 1;
  }

  return key;
};

// message 保持时间
const timeNum = 5000;

/**
 * 手动关闭弹窗
 */

const messageCom = {
  success: (text) => {
    const key = keyRender(text);
    message.success({
      content: text,
      key,
      duration: timeNum / 1000
    });

    setTimeout(() => {

      message.destroy(key);
    }, timeNum);
  },
  error: (text) => {
    const key = keyRender(text);
    let timerId = null;
    message.error({
      content: text,
      key,
      onClose: () => {
        if (timerId) {
          clearTimeout(timerId);
        }
      },
      duration: timeNum / 1000
    });

    timerId = setTimeout(() => {
      message.destroy(key);
    }, timeNum);
  },
  info: (text) => {
    const key = keyRender(text);
    message.info({
      content: text,
      key,
      duration: timeNum / 1000
    });

    setTimeout(() => {
      message.destroy(key);
    }, timeNum);
  },
  warning: (text) => {
    const key = keyRender(text);
    if(timeFlag[text] && timeFlag[text] > 1) return;

    message.warning({
      content: text,
      key,
      duration: timeNum / 1000
    });

    setTimeout(() => {
      message.destroy(key);

      if (timeFlag[text]) {
        timeFlag[text] = undefined;
        delete timeFlag[text];
      }
    }, timeNum);
  },
  warn: (text) => {
    const key = keyRender(text);
    message.warn({
      content: text,
      key,
      duration: timeNum / 1000
    });

    setTimeout(() => {
      message.destroy(key);
    }, timeNum);
  },
  loading: (text) => {
    const key = keyRender(text);
    message.loading({
      content: text,
      key,
      duration: timeNum / 1000
    });

    setTimeout(() => {
      message.destroy(key);
    }, timeNum);
  },
}

export default messageCom;
